import { Badge } from "@mantine/core";
import HubspotIcon from "../../../../../assets/images/hubspot.svg?react";
import SlackIcon from "../../../../../assets/images/slack.svg?react";
import SegmentIcon from "../../../../../shared/ui/icons/SegmentIcon";
import HeIcon from "../../../../../assets/images/heSm.svg?react";

interface SourceBadgeProps {
  source: string;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xs';
}

const SourceBadge = ({ source, showIcon = false, size = 'sm' }: SourceBadgeProps) => {
  const getSourceConfig = () => {
    switch (source.toLowerCase()) {
      case 'native':
      case 'hyperengage':
        return { color: 'dark', text: 'Native', icon: <HeIcon className="!w-3 !h-3" /> };
      case 'hubspot':
        return { color: 'dark', text: 'HubSpot', icon: <HubspotIcon className="!w-3 !h-3" /> };
      case 'slack':
        return { color: 'dark', text: 'Slack', icon: <SlackIcon className="!w-3 !h-3" /> };
      case 'segment':
        return { color: 'dark', text: 'Segment', icon: <SegmentIcon className="!w-3 !h-3" /> };
      case 'stripe':
        return { color: 'dark', text: 'Stripe', icon: null };
      case 'external':
        return { color: 'dark', text: 'External', icon: null };
      default:
        return { color: 'dark', text: source, icon: null };
    }
  };

  const { color, text, icon } = getSourceConfig();

  return (
    <Badge
      size={size}
      color={color}
      variant="light"
      leftSection={showIcon && icon ? icon : undefined}
    >
      {text}
    </Badge>
  );
};

export default SourceBadge;
